import { SidebarMenuItemProps } from '@superdispatch/ui-lab';
import { ReactNode } from 'react';
import { SidebarMenuItemLink } from 'shared/routing/SidebarMenuItemLink';
import { usePathnameMatch } from 'shared/routing/usePathnameMatch';

interface ReportsSidebarMenuItemLinkProps extends SidebarMenuItemProps {
  to: string;
  children: ReactNode;
}

export function ReportsSidebarMenuItemLink({
  to,
  children,
  ...props
}: ReportsSidebarMenuItemLinkProps) {
  const isCurrentPage = usePathnameMatch(to);

  return (
    <SidebarMenuItemLink
      {...props}
      to={to}
      onClick={(event) => {
        if (isCurrentPage) event.preventDefault();
        props.onClick?.(event);
      }}
    >
      {children}
    </SidebarMenuItemLink>
  );
}
